import type { ConversationHistoryItem } from "src/api/conversationHistory";

/**
 * In-app route for a history item. A project conversation opens at the
 * project's chat stage — the same conversation the project tree opens
 * (Story 16 AC 7) — and a general one at the plain assistant chat.
 *
 * Its own module rather than living beside the modal: the rows need it to
 * build a share link, and the rows are what the modal renders.
 */
export const conversationPath = (item: ConversationHistoryItem) =>
  item.in_project && item.project_folder_id !== null
    ? `/assistant/projects/folder/${item.project_folder_id}/chat/${item.id}`
    : `/assistant/chat/${item.id}`;

/**
 * Absolute link to a conversation, for copying out of the app.
 *
 * The share modal shows the reader the URL it is about to copy, so it needs
 * the whole thing — a router path pasted into a message goes nowhere.
 */
export const conversationShareUrl = (item: ConversationHistoryItem) =>
  `${window.location.origin}${conversationPath(item)}`;
